export default {
  viewBox: "0 0 16 16",
  html: "<path fill=\"#E66073\" fill-rule=\"evenodd\" d=\"M1.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0M8 5.5a.5.5 0 0 1 .5.5v2.5a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5M8 11a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1\" clip-rule=\"evenodd\"/>"
};